
import { withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

const BorderLinear = ({ value, height, width, borderRadius, primaryBackColor, barBackColor }) => {
    const BorderLinearProgress = withStyles(() => ({
        root: {
            height: height,
            width: width,
            borderRadius: borderRadius,
        },
        colorPrimary: {
            backgroundColor: primaryBackColor,
        },
        bar: {
            borderRadius: borderRadius,
            backgroundColor: barBackColor,
        },
    }))(LinearProgress);

    return (
        <>
            <BorderLinearProgress variant="determinate" value={value} />
        </>
    )
}

export default BorderLinear;
